import { Component, Input, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-popover-data',
  templateUrl: './popover-data.component.html',
  styleUrls: ['./popover-data.component.scss'],
})
export class PopoverDataComponent implements OnInit {

  @Input() currentData: string;
  @Input() from: boolean;

  constructor(
    private popoverController: PopoverController,
  ) { }

  ngOnInit() {  }

  async chiudiPopoverData() {
    const ret = {
      data: this.currentData,
      from: this.from
    }
    await this.popoverController.dismiss(ret);
  }
}